/** Deterministic unit float in [0, 1) from an integer seed. */
export function unitFromSeed(seed: number): number {
  let value = seed | 0;
  value = Math.imul(value ^ (value >>> 15), value | 1);
  value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
  return ((value ^ (value >>> 14)) >>> 0) / 0x1_0000_0000;
}

export function createTurnRng(turn: number): () => number {
  let call = 0;
  return () => {
    const sample = unitFromSeed(Math.imul(turn, 1_000_003) + call);
    call += 1;
    return sample;
  };
}
